<script setup>
  import { ref, computed, watchEffect } from 'vue';
  import { useSpotStore } from "@/stores/SpotStore";  
  import { useCompleteReportStore } from '@/stores/CompleteReportStore';
  import DataContainer from "@/components/DataContainer.vue";
  import CurrentConditionsGauge from "@/components/CurrentConditionsGauge.vue";
  import CurrentConditionsData from "@/components/CurrentConditionsData.vue";
  import Icon from "@/components/icons/Icon.vue";

  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();     

  const emit = defineEmits(['containerOpen:change'])


  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const spotStore = useSpotStore();
  const completeReportStore = useCompleteReportStore();

  const containerOpen = ref(completeReportStore.currentConditionsStartingView === 'expanded');

  const hasMessage = computed(() => !!spotStore.spotMessage || !!spotStore.statusMessage);
  const showMessages = computed(() => hasMessage.value && $WEB_VIEW);
  const showMessageIcon = computed(() => !!spotStore.spotMessage && !containerOpen.value && $WEB_VIEW);
  const showSpotMessage = computed(() => !!spotStore.spotMessage && containerOpen.value && $WEB_VIEW);

  const handleContainerOpen = () => {
    containerOpen.value = !containerOpen.value;
  }

  watchEffect(() => emit('containerOpen:change', containerOpen.value));
</script>

<template>
  <DataContainer class="jwx-complete-report-combo" :data-open="containerOpen" :data-messages="hasMessage">
    <CurrentConditionsGauge :upgrade="props.upgrade" :hideDescription="true" />
    <CurrentConditionsData v-if="containerOpen" :upgrade="props.upgrade" />
    <CurrentConditionsData v-else
      :upgrade="props.upgrade"
      :tagList="true"
      :allowedDataValues="['windGust', 'airTemp', 'airPressure', 'waterTemp']"
      :hideSource="true"
    />
    <div v-if="showMessages" class="jwx-current-conditions-messages">
      <p v-if="showSpotMessage" class="jwx-current-conditions-message jwx-page-header__meta"><span class="jwx-page__meta-label">Special Note:</span><br><span v-html= spotStore.spotMessage></span></p>
      <p v-if="spotStore.statusMessage" class="jwx-current-conditions-message jwx-page-header__meta"><span class="jwx-page__meta-label">Status Message:</span> {{ spotStore.statusMessage }}</p>
    </div>
    <button @click.prevent="handleContainerOpen" class="jwx-current-conditions-combo__control">
      <Icon name="chevron-right" class="jwx-current-conditions-combo__control-icon" />
      <div v-if="showMessageIcon" class="jwx-current-conditions-combo__control-message-icon">
        <Icon name="info" />
      </div>
    </button>
  </DataContainer>
</template>